import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@walmart-web/livingdesign-components';
import Grid from '@mui/material/Grid';

export default function ShimmerRCA() {
	const useStyles = makeStyles(() => ({
		header: {
			marginTop: '5%',
			marginLeft: '2%',
		},
		gridContainer: {
			display: 'flex',
		},
		container: {
			marginTop: '2%',
			border: '1px solid #dadce0',
			borderRadius: '8px',
			height: '120px',
			width: '100%',
			marginRight: '4%',
		},
		metricPanel: {
			display: 'flex',
			justifyContent: 'space-between',
			padding: '24px',
		},
		metricTab: {
			display: 'flex',
			flexDirection: 'column',
			gap: '16px',
		},
		metricTabInfo: {
			marginTop: '6%',
			display: 'flex',
			flexDirection: 'column',
			gap: '16px',
		},
		marketSnapshot: {
			marginTop: '1.3%',
		},
		rcTableContainer: {
			border: '1px solid #dadce0',
			borderRadius: '8px',
			height: '550px',
			display: 'flex',
			marginRight: '4%',
		},
		rcTableLeftPanel: {
			borderRight: '1px solid #dadce0',
			width: '20%',
			height: '100%',
		},
		rootCause: {
			height: '40px',
			borderBottom: '1px solid #dadce0',
			padding: '16px 8px 16px 8px',
		},
		rc: {
			marginLeft: '25%',
		},
		containerTable: {
			marginTop: '2%',
			border: '1px solid #dadce0',
			borderRadius: '8px',
			height: '120px',
			width: '90%',
			marginLeft: '2%',
			marginRight: '2%',
		},
	}));

	const classes = useStyles();

	return (
		<Grid container className={classes.header}>
			<Grid item xs={12} sm={12} md={12} lg={12}>
				<Box style={{ display: 'flex' }}>
					<Skeleton height="17.5px" width="130px" variant="rounded" />
					<Box style={{ marginLeft: '10px' }}>
						<Skeleton height="17.5px" width="130px" variant="rounded" />
					</Box>
				</Box>
				<Box style={{ marginTop: '2%', marginBottom: '2%' }}>
					<Skeleton height="17.5px" width="260px" variant="rounded" />
				</Box>
				<Box style={{ display: 'flex' }}>
					<Skeleton height="17.5px" width="130px" variant="rounded" />
					<Box style={{ marginLeft: '10px' }}>
						<Skeleton height="17.5px" width="130px" variant="rounded" />
					</Box>
				</Box>
			</Grid>

			{/* Snapshot */}

			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				lg={12}
				className={classes.gridContainer}>
				<Box className={classes.container}>
					<Box className={classes.metricPanel}>
						{[1, 2, 3, 4, 4]?.map((tab) => (
							<Box key={tab.value} className={classes.metricTab}>
								<Skeleton height="14.5px" width="100px" variant="rounded" />

								<Box className={classes.metricTabInfo}>
									<Skeleton height="12.5px" width="100px" variant="rounded" />
								</Box>
							</Box>
						))}
					</Box>
				</Box>
				<Box className={classes.container}>
					<Box className={classes.metricPanel}>
						<Box className={classes.metricTab}>
							<Skeleton height="14.5px" width="140px" variant="rounded" />
							<Box className={classes.marketSnapshot}>
								<Skeleton height="12.5px" width="700px" variant="rounded" />
							</Box>
						</Box>
					</Box>
				</Box>
			</Grid>

			{/* Table */}

			<Box style={{ marginTop: '3%', marginBottom: '2%' }}>
				<Skeleton height="17.5px" width="129px" variant="rounded" />
			</Box>

			<Grid item xs={12} sm={12} md={12} lg={12}>
				<Box className={classes.rcTableContainer}>
					<Box className={classes.rcTableLeftPanel}>
						<Box className={classes.rootCause}>
							<Box className={classes.rc}>
								<Skeleton height="14.5px" width="129px" variant="rounded" />
								<Box style={{ marginTop: '15px' }}>
									<Skeleton height="12.5px" width="129px" variant="rounded" />
								</Box>
							</Box>
						</Box>
						<Box className={classes.rootCause}>
							<Box className={classes.rc}>
								<Skeleton height="14.5px" width="129px" variant="rounded" />
								<Box style={{ marginTop: '15px' }}>
									<Skeleton height="12.5px" width="129px" variant="rounded" />
								</Box>
							</Box>
						</Box>
						<Box className={classes.rootCause}>
							<Box className={classes.rc}>
								<Skeleton height="14.5px" width="129px" variant="rounded" />
								<Box style={{ marginTop: '15px' }}>
									<Skeleton height="12.5px" width="129px" variant="rounded" />
								</Box>
							</Box>
						</Box>
						<Box className={classes.rootCause}>
							<Box className={classes.rc}>
								<Skeleton height="14.5px" width="129px" variant="rounded" />
								<Box style={{ marginTop: '15px' }}>
									<Skeleton height="12.5px" width="129px" variant="rounded" />
								</Box>
							</Box>
						</Box>
					</Box>
					<Box className={classes.containerTable}>
						<Box className={classes.metricPanel}>
							{[1, 2, 3, 4, 4]?.map((tab) => (
								<Box key={tab.value} className={classes.metricTab}>
									<Skeleton height="14.5px" width="100px" variant="rounded" />

									<Box className={classes.metricTabInfo}>
										<Skeleton height="12.5px" width="100px" variant="rounded" />
									</Box>
								</Box>
							))}
						</Box>
					</Box>
				</Box>
			</Grid>
		</Grid>
	);
}
